<template>
  <div class="page-container">
    <el-card v-loading="loading">
      <div slot="header" class="page-header">
        <span class="page-title">服务订单详情</span>
        <div class="page-actions">
          <el-button size="small" icon="el-icon-arrow-left" @click="$router.push('/order/service')">返回列表</el-button>
        </div>
      </div>

      <template v-if="detail.id">

        <!-- ① 基础信息 -->
        <div class="section-title">基础信息</div>
        <el-form label-width="120px" size="small" class="detail-form">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="服务订单号"><span class="val-text">{{ detail.service_no }}</span></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="服务订单状态">
                <el-tag :type="svcStatusType(detail.status)" size="small">
                  {{ detail.status_label || svcStatusLabel(detail.status) }}
                </el-tag>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品订单号">
                <el-button
                  type="text"
                  @click="$router.push(`/order/product/detail?id=${detail.product_order_id}`)"
                >{{ detail.product_order_no }}</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="购买人姓名"><span class="val-text">{{ detail.user_name || '—' }}</span></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="购买人手机号"><span class="val-text">{{ detail.user_phone || '—' }}</span></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品名称"><span class="val-text">{{ detail.product_name || '—' }}</span></el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="创建时间"><span class="val-text">{{ detail.created_at }}</span></el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- ② 服务用户信息 -->
        <template v-if="detail.service_order_user">
          <div class="section-title">服务用户信息</div>
          <el-form label-width="120px" size="small" class="detail-form">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="姓名">
                  <span class="val-text">{{ detail.service_order_user.name || '—' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="年龄">
                  <span class="val-text">{{ detail.service_order_user.age != null ? detail.service_order_user.age + ' 岁' : '—' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="性别">
                  <span class="val-text">{{ genderLabel(detail.service_order_user.gender) }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系方式">
                  <span class="val-text">{{ detail.service_order_user.phone || '—' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="身份证号">
                  <span class="val-text">{{ detail.service_order_user.id_card || '—' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="采样方式">
                  <span class="val-text">{{ sampleMethodLabel(detail.service_order_user.sample_method) }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="预约上门时间">
                  <span class="val-text">{{ detail.service_order_user.appointment_at || '—' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="预约上门地址">
                  <span class="val-text">{{ detail.service_order_user.appointment_address || '—' }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注">
                  <span class="val-text">{{ detail.service_order_user.remark || '—' }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </template>
        <template v-else>
          <div class="section-title">服务用户信息</div>
          <div class="empty-hint">暂无服务用户信息</div>
        </template>

        <!-- ③ 合伙人信息 -->
        <div class="section-title">合伙人信息</div>
        <template v-if="detail.partner_id">
          <el-form label-width="120px" size="small" class="detail-form">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="合伙人姓名"><span class="val-text">{{ detail.partner_name || '—' }}</span></el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="合伙人手机号"><span class="val-text">{{ detail.partner_phone || '—' }}</span></el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </template>
        <div v-else class="empty-hint">暂未绑定合伙人</div>

        <!-- ④ 采血师信息（组织采样时不显示） -->
        <template v-if="isBloodSample">
          <div class="section-title">采血师信息</div>
          <el-form label-width="120px" size="small" class="detail-form">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="采血师姓名">
                  <span v-if="(detail.service_order_detail || {}).collector_name" class="val-text">
                    {{ detail.service_order_detail.collector_name }}
                  </span>
                  <span v-else class="val-empty">暂未录入</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="采血师联系方式">
                  <span v-if="(detail.service_order_detail || {}).collector_phone" class="val-text">
                    {{ detail.service_order_detail.collector_phone }}
                  </span>
                  <span v-else class="val-empty">暂未录入</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </template>

        <!-- ⑦ 签名信息（仅血液采样时显示） -->
        <template v-if="isBloodSample">
          <div class="section-title">签名信息</div>
          <el-form label-width="120px" size="small" class="detail-form">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="签名状态">
                  <el-tag :type="detail.sign_status === 1 ? 'success' : 'info'" size="small">
                    {{ detail.sign_status === 1 ? '已签名' : '未签名' }}
                  </el-tag>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="签名时间">
                  <span v-if="detail.signed_at" class="val-text">{{ detail.signed_at }}</span>
                  <span v-else class="val-empty">—</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="签名PDF">
                  <template v-if="detail.signed_pdf_url">
                    <span class="val-text report-url">{{ detail.signed_pdf_url }}</span>
                    <el-button
                      type="primary" size="mini" icon="el-icon-document"
                      style="margin-left:10px"
                      @click="openReport(detail.signed_pdf_url)"
                    >查看</el-button>
                  </template>
                  <span v-else class="val-empty">暂无签名PDF</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </template>

        <!-- ⑤ 上门信息 -->
        <div class="section-title">上门信息</div>
        <el-form label-width="120px" size="small" class="detail-form">
          <el-row :gutter="24">
            <!-- 血液样本编码：组织采样时不显示 -->
            <el-col v-if="isBloodSample" :span="12">
              <el-form-item label="血液样本编码">
                <span v-if="(detail.service_order_detail || {}).sample_code" class="val-text">
                  {{ detail.service_order_detail.sample_code }}
                </span>
                <span v-else class="val-empty">暂未录入</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="快递公司">
                <span v-if="(detail.service_order_detail || {}).express_company" class="val-text">
                  {{ expressCompanyLabel(detail.service_order_detail.express_company) }}
                </span>
                <span v-else class="val-empty">暂未录入</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="快递单号">
                <span v-if="(detail.service_order_detail || {}).express_no" class="val-text">
                  {{ detail.service_order_detail.express_no }}
                </span>
                <span v-else class="val-empty">暂未录入</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- ⑥ 检测报告 -->
        <div class="section-title">
          <span>检测报告</span>
          <el-button
            v-if="detail.status === 6 || detail.status === 7"
            v-permission="['order:service:uploadReport']"
            type="success" size="mini" icon="el-icon-upload2"
            style="margin-left:12px;vertical-align:middle"
            @click="openReportDialog"
          >{{ (detail.report_list && detail.report_list.length > 0) ? '重新上传报告' : '上传报告' }}</el-button>
        </div>
        <template v-if="detail.report_list && detail.report_list.length > 0">
          <el-table
            :data="detail.report_list"
            border
            stripe
            size="small"
            style="margin:0 12px 16px;width:calc(100% - 24px)"
          >
            <el-table-column label="序号" type="index" width="60" align="center" />
            <el-table-column label="上传时间" prop="created_at" width="180" />
            <el-table-column label="审核状态" width="110" align="center">
              <template slot-scope="{ row }">
                <el-tag
                  :type="row.review_status === 1 ? 'success' : 'warning'"
                  size="small"
                >{{ row.review_status_label }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="审核时间" width="180">
              <template slot-scope="{ row }">
                <span v-if="row.reviewed_at">{{ row.reviewed_at }}</span>
                <span v-else class="val-empty">—</span>
              </template>
            </el-table-column>
            <el-table-column label="报告文件" min-width="160" show-overflow-tooltip>
              <template slot-scope="{ row }">
                <span class="report-url-cell">{{ row.report_url }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100" align="center" fixed="right">
              <template slot-scope="{ row }">
                <el-button
                  type="primary" size="mini" icon="el-icon-document"
                  @click="openReport(row.report_url)"
                >查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <div v-else class="empty-hint" style="margin:0 12px 16px">暂未上传检测报告</div>

      </template>
    </el-card>

    <!-- 上传检测报告（与列表页一致，用于重新上传） -->
    <el-dialog title="上传检测报告" :visible.sync="reportDialog.visible" width="440px" @close="resetReportDialog">
      <div class="upload-hint">请选择 PDF 格式的检测报告文件</div>
      <el-upload
        ref="reportUpload"
        action="#"
        accept=".pdf"
        :limit="1"
        :auto-upload="false"
        :on-change="onReportFileChange"
        :on-remove="() => { reportDialog.file = null }"
        :file-list="[]"
      >
        <el-button size="small" icon="el-icon-folder-opened">选择文件</el-button>
        <span slot="tip" class="el-upload__tip" style="margin-left:8px">仅支持 .pdf</span>
      </el-upload>
      <span slot="footer">
        <el-button @click="reportDialog.visible = false">取消</el-button>
        <el-button type="primary" :loading="reportDialog.submitting" @click="submitReport">确定上传</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getServiceOrderDetail, uploadReport } from '@/api/order'

const SERVICE_STATUS = {
  0: { label: '待录入', type: 'info' },
  1: { label: '待服务', type: 'warning' },
  2: { label: '待分配', type: 'warning' },
  3: { label: '待联系', type: '' },
  4: { label: '待上门', type: '' },
  5: { label: '待发件', type: '' },
  6: { label: '待检测', type: '' },
  7: { label: '已完成', type: 'success' },
  8: { label: '已退款', type: 'danger' }
}

export default {
  name: 'ServiceOrderDetail',
  data() {
    return {
      loading: false,
      detail: {},
      reportDialog: {
        visible: false,
        submitting: false,
        serviceOrderId: null,
        file: null
      }
    }
  },
  computed: {
    // 采样方式不为"组织"时显示采血师信息和血液样本编码
    isBloodSample() {
      return (this.detail.service_order_user || {}).sample_method !== 'tissue'
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        if (to.path !== '/order/service/detail') return
        if (to.query.id) this.fetchDetail(Number(to.query.id))
      }
    }
  },
  methods: {
    async fetchDetail(id) {
      this.loading = true
      try {
        const res = await getServiceOrderDetail({ service_order_id: id })
        this.detail = res.data || {}
      } catch {
        this.$message.error('加载失败，请重试')
      } finally {
        this.loading = false
      }
    },

    openReport(url) {
      window.open(url, '_blank')
    },

    openReportDialog() {
      if (!this.detail.id) return
      this.reportDialog.serviceOrderId = this.detail.id
      this.reportDialog.file = null
      this.reportDialog.visible = true
    },
    onReportFileChange(file) {
      this.reportDialog.file = file.raw
    },
    resetReportDialog() {
      this.reportDialog.file = null
      this.reportDialog.serviceOrderId = null
      if (this.$refs.reportUpload) this.$refs.reportUpload.clearFiles()
    },
    async submitReport() {
      if (!this.reportDialog.file) {
        return this.$message.warning('请先选择 PDF 文件')
      }
      this.reportDialog.submitting = true
      try {
        await uploadReport(this.reportDialog.serviceOrderId, this.reportDialog.file)
        this.$message.success('检测报告上传成功')
        this.reportDialog.visible = false
        await this.fetchDetail(Number(this.$route.query.id))
      } catch (e) {
        this.$message.error(e.message || '上传失败，请重试')
      } finally {
        this.reportDialog.submitting = false
      }
    },

    svcStatusType(s) { return (SERVICE_STATUS[s] || {}).type || '' },
    svcStatusLabel(s) { return (SERVICE_STATUS[s] || {}).label || String(s) },
    genderLabel(g) {
      if (g === 1) return '男'
      if (g === 2) return '女'
      return '—'
    },
    sampleMethodLabel(m) {
      if (m === 'blood') return '血液'
      if (m === 'tissue') return '组织'
      return m || '—'
    },
    expressCompanyLabel(code) {
      const map = {
        SF: '顺丰',
        ZTO: '中通',
        YTO: '圆通',
        STO: '申通',
        YUNDA: '韵达',
        JD: '京东',
        EMS: 'EMS'
      }
      const name = map[code]
      return name ? `${name}（${code}）` : code
    }
  }
}
</script>

<style lang="scss" scoped>
.page-header  { display: flex; justify-content: space-between; align-items: center; }
.page-title   { font-size: 16px; font-weight: 600; }
.page-actions { display: flex; gap: 8px; }

.section-title {
  display: flex;
  align-items: center;
  font-size: 14px; font-weight: 600; color: #303133;
  margin: 24px 0 12px;
  padding-left: 10px;
  border-left: 3px solid #409EFF;
}

.detail-form { padding: 0 12px; }

.val-text  { color: #303133; }
.val-empty { color: #c0c4cc; font-size: 13px; }
.empty-hint { color: #909399; font-size: 13px; padding: 8px 12px; }

.report-url {
  display: inline-block;
  max-width: 420px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
.report-url-cell {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #303133;
  font-size: 12px;
}

.upload-hint { color: #606266; font-size: 13px; margin-bottom: 12px; }
</style>
